import axios, { AxiosResponse } from "axios";
import i18n from "../../i18n";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

// Тип ответа аутентификации
interface AuthResponse {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  refresh_token: string;
  token_type: string;
  id_token: string;
  'not-before-policy': number;
  session_state: string;
  scope: string;
}

interface AuthApiResponse {
  status: string;
  data: AuthResponse;
}

// Функция аутентификации
export const authenticate = async (login: string, password: string): Promise<AuthResponse> => {
  try {
    const response: AxiosResponse<AuthApiResponse> = await axios.post(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/users/authorize`,
      {
        login: login,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Ошибка при аутентификации:", error);
    throw error;
  }
};


// Функция для обновления refreshToken
export const refreshToken = async (refreshToken: string): Promise<any> => {
  try {
    const accessToken = Cookies.get("access_token");
    const response: AxiosResponse<any> = await axios.post(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/users/refresh-token`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при обновлении токена:", error);
    throw error;
  }
};


// Функция для выхода из системы (logout)
export const logoutUser = async (refreshToken: string): Promise<void> => {
  try {
    const accessToken = Cookies.get("access_token");
    await axios.post(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/users/logout`,
      {
        refreshToken: refreshToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
      }
    );
    console.log("Успешный выход из системы");
  } catch (error) {
    console.error("Ошибка при выходе из системы:", error);
    throw error;
  }
};


interface UserResponse {
  firstname: string;
  lastname: string;
  email: string;
  role: string[];
  id: number;
  login: string;
  isActive: boolean;
  isDeleted: boolean;
  isSuperadmin: boolean;
  createdAt: string;
  roles: any[];
}

// Получение Superset guest token для встраивания
export const getSupersetGuestToken = async (dashboardId: number | string): Promise<string> => {
  try {
    const accessToken = Cookies.get("access_token");
    const response: AxiosResponse<{ token?: string; guest_token?: string; result?: string }> = await apiClient.get(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/api/superset/guest-token`,
      {
        params: { dashboard_id: dashboardId },
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        withCredentials: true,
      }
    );
    const data = response.data || {};
    return data.token || data.guest_token || data.result || "";
  } catch (error) {
    console.error("Ошибка при получении Superset guest token:", error);
    throw error;
  }
};

export const getUserInfo = async (): Promise<UserResponse> => {
  try {
    // Извлекаем токен из куков
    const token = Cookies.get("access_token");
console.log(123, token);

    const response: AxiosResponse<UserResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/users/me`,
      {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении информации о пользователе:", error);
    throw error;
  }
};

// Интерфейс ответа для поиска модулей с правами
interface ModulesPermissionsResponse {
  status: string;
  message: string;
  data: any;
}

// Поиск модулей с правами по имеющимся ролям пользователя
export const searchModulesPermissions = async (): Promise<ModulesPermissionsResponse> => {
  try {
    const accessToken = Cookies.get("access_token");
    
    if (!accessToken) {
      throw new Error("Токен доступа не найден");
    }

    const response: AxiosResponse<ModulesPermissionsResponse> = await apiClient.get(
      `${process.env.REACT_APP_URL_AUTH_SERVICE}/users/search-modules-permissions`,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Ошибка при поиске модулей с правами:", error);
    throw error;
  }
};